import { Button } from 'antd';
import { red, green } from '@ant-design/colors';
import { CloseOutlined, CheckOutlined } from '@ant-design/icons';

const ValidateButton = ({ hasError, ...restProps }) => {
  const style = hasError
    ? { borderColor: red[4], color: red[4] }
    : { borderColor: green[6], color: green[6] };

  return (
    <Button
      style={style}
      type='ghost'
      icon={hasError ? <CloseOutlined /> : <CheckOutlined />}
      {...restProps}
    >
      Validate
    </Button>
  );
};

export default ValidateButton;
